/**
 * Generate SHA1 hash of input string using Web Crypto API
 * @param input - The string to hash
 * @returns Promise that resolves to SHA1 hash as hex string, or empty string if input is invalid or crypto is unavailable
 */
export const generateSha1Hash = async (input: string): Promise<string> => {
  if (!input || !crypto?.subtle) return '';
  try {
    const hashBuffer = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(input));
    return Array.from(new Uint8Array(hashBuffer), (b) => b.toString(16).padStart(2, '0')).join('');
  } catch (_error) {
    // Failed to generate SHA1 hash
    return '';
  }
};

export default generateSha1Hash;
